import jQuery from 'jquery';

// The plugins and script.js expect jQuery as a global
window.$ = window.jQuery = jQuery;
